/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_WsInputs */

const en_cp_mock_ws = /** @type {(inputs: Cp_Mock_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team 07 · Clinic Queue System`)
};

const id_cp_mock_ws = /** @type {(inputs: Cp_Mock_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim 07 · Sistem Antrean Puskesmas`)
};

/**
* | output |
* | --- |
* | "Team 07 · Clinic Queue System" |
*
* @param {Cp_Mock_WsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_ws = /** @type {((inputs?: Cp_Mock_WsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_WsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_ws(inputs)
	return en_cp_mock_ws(inputs)
});